(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('inArray', inArray);

    function inArray() {
        return function (value, arr) {
            if (!(arr instanceof Array)) {
                return false;
            }
            return arr.indexOf(value) > -1;
        };
    }
})();